import { dataUserCard } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserCard = /*#__PURE__*/createIcon(dataUserCard)
export default IconUserCard
